import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import dashboardModule from './modules/dashboard';
import listingDetailModule from './modules/listing-detail';
import listingsModule from './modules/listings';
import activeListingModule from './modules/active-listings';
import deactiveListingModule from './modules/deactive-listings';
import newListingModule from './modules/new-listing';
import usersModule from './modules/users';
import accountModule from './modules/account-info';
import messagesModule from './modules/messages';
import rentalsModule from './modules/rentals';
import newRentalModule from './modules/new-rental';
import invoicesModule from './modules/invoices';
import userNotificationsModule from './modules/user-notifications';

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        dashboard: dashboardModule,
        listingDetail: listingDetailModule,
        listings: listingsModule,
        activeListings: activeListingModule,
        deactiveListings: deactiveListingModule,
        newListing: newListingModule,
        users: usersModule,
        accountInfo: accountModule,
        messages: messagesModule,
        rentals: rentalsModule,
        invoices: invoicesModule,
        newRental: newRentalModule,
        userNotifications: userNotificationsModule
    }
});
